import { render, staticRenderFns } from "./SummaryAvailability.vue?vue&type=template&id=6639e4da&scoped=true&"
import script from "./SummaryAvailability.vue?vue&type=script&lang=js&"
export * from "./SummaryAvailability.vue?vue&type=script&lang=js&"
import style0 from "./SummaryAvailability.vue?vue&type=style&index=0&id=6639e4da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6639e4da",
  null
  
)

export default component.exports